import {NgModule} from "@angular/core";
import {Routes, RouterModule} from "@angular/router";
import {AboutComponent} from "./components/pages/about/about.component";
import {LoginComponent} from "./components/pages/login/login.component";
import {CreateAccountComponent} from "./components/pages/create-account/create-account.component";
import {ErrorComponent} from "./components/pages/error/error.component";
import {ContactComponent} from "./components/pages/contact/contact.component";
import {SubscriptionSuccessComponent} from "./components/pages/subscription-success/subscription-success.component";
import {AuthGuard} from "src/guards/auth.guard";
import {RolesGuard} from "src/guards/roles.guard";
import {HomeComponent} from "./components/pages/home/home.component";
import {QuicklinkStrategy} from 'ngx-quicklink';
import {MissionsComponent} from "./components/pages/missions/missions.component";
import {MailConfirmedComponent} from "./components/pages/mail-confirmed/mail-confirmed.component";
import {PaymentFirstStepComponent} from "./components/pages/payment-first-step/payment-first-step.component";
import {MailUnconfirmedComponent} from "./components/pages/mail-unconfirmed/mail-unconfirmed.component";
import {
  EmailSentSuccessfullyComponent
} from "./components/pages/email-sent-successfully/email-sent-successfully.component";
import {PaymentSuccessfulComponent} from "./components/pages/payment-successful/payment-successful.component";
import {MaintenanceComponent} from "./components/pages/maintenance/maintenance.component";
import {AxesComponent} from "./components/pages/axes/axes.component";
import { CompanyLoginComponent } from "./components/pages/company-login/company-login.component";
import { ValidationCodeComponent } from "./components/pages/validation-code/validation-code.component";
import { ChooseLoginComponent } from "./components/pages/choose-login/choose-login.component";

const routes: Routes = [
  {path: "", component: HomeComponent, title: "QUALIFPME | ACCUEIL"},
  {path: "about", component: AboutComponent, title: "QUALIFPME | A PROPOS DE LA BSTP"},
  {path: "login", component: LoginComponent, title: "QUALIFPME | CONNEXTION"},
  {
    path: "create-account",
    component: CreateAccountComponent,
    title: "QUALIFPME | FORMULAIRE DE DEMANDE DE CRÉATION D'UNE ENTREPRISE"
  },
  {path: "404", component: ErrorComponent, title: "QUALIFPME | ERREUR 404"},
  {path: "contact", component: ContactComponent, title: "QUALIFPME | CONTACTEZ-NOUS"},
  {
    path: 'login-as-company',
    component: CompanyLoginComponent,
    title: "QUALIFPME | CONNEXION",
    data: {
      preload: true,
    }
  },
  {
    path: 'code-confirmation',
    component: ValidationCodeComponent,
    title: "QUALIFPME | CONFIRMATION DE CODE",
    data: {
      preload: true,
    }
  },
  {
    path: 'choose-login',
    component: ChooseLoginComponent,
    title: "QUALIFPME | CHOISIR UN TYPE DE LOGIN",
    data: {
      preload: true,
    }
  },
  {
    path: 'campagne',
    loadChildren: () => import('./components/pages/campagne/campagne.module').then(m => m.CampagneModule),
    title: 'Campagne',
    canActivate: [AuthGuard, RolesGuard],
    data: {
      role: ['campagne',],
      preload: true,
    }
  },
  {
    path: 'administration',
    loadChildren: () => import('./components/pages/administration/administration.module').then(m => m.AdministrationModule),
    title: 'Administration',
    canActivate: [AuthGuard, RolesGuard],
    data: {
      preload: true,
      role: ['administration',]
    }
  },
  {
    path: 'verificator',
    loadChildren: () => import('./components/pages/verificator/verificator.module').then(m => m.VerificatorModule),
    data: {
      preload: true,
      role: ['verificator']
    },
    title: 'Verification',
    canActivate: [AuthGuard, RolesGuard]
  },

  {
    path: 'evaluator',
    loadChildren: () => import('./components/pages/evaluator/evaluator.module').then(m => m.EvaluatorModule),
    data: {
      preload: true,
      role: ['evaluator']
    },
    title: "Evaluation",
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: 'questionnaires',
    loadChildren: () => import('./components/pages/questionnaires/questionnaires.module').then(m => m.QuestionnairesModule),
    data: {
      preload: true,
      role: ['questionnaires',]
    },
    canActivate: [],
    title: 'Questionnaires',
  },
  {
    path: 'company',
    loadChildren: () => import('./components/pages/company/company.module').then(m => m.CompanyModule),
    data: {
      preload: true,
      role: ['company',]
    },
    title: "Entreprise"
  },
  {
    path: "registration-success",
    component: SubscriptionSuccessComponent,
    title: "QUALIFPME | SUCCES",
    data: {
      preload: true
    }
  },

  {
    path: 'missions',
    component: MissionsComponent,
    title: "QUALIFPME | MISSIONS",
    data: {
      preload: true,
    }
  },

  {
    path: 'mail-confirmed',
    component: MailConfirmedComponent,
    title: "QUALIFPME | Vérification de l'Email Réussie",
    data: {
      preload: true,
    }
  },
  {
    path: 'mail-unconfirmed',
    component: MailUnconfirmedComponent,
    title: "QUALIFPME | Vérification de l'Email Échouée",
    data: {
      preload: true,
    }
  },
  {
    path: 'company/payment-first-step/:reference',
    component: PaymentFirstStepComponent,
    title: "QUALIFPME | Procédez au Paiement",
    data: {
      preload: true,
    }
  },

  {
    path: 'email-sent-successfully',
    component: EmailSentSuccessfullyComponent,
    title: "QUALIFPME | EMAIL ENVOYÉ AVEC SUCCÈS",
    data: {
      preload: true,
    }
  },
  {
    path: 'company/payment-successful/:reference',
    component: PaymentSuccessfulComponent,
    title: "QUALIFPME | PAIEMENT EFFECTUÉ AVEC SUCCÈS",
    data: {
      preload: true,
    }
  },

  {
    path: 'maintenance',
    component: MaintenanceComponent,
    title: "ERREUR DE CONNEXION",
    data: {
      preload: true
    }
  },
  {
    path: 'axes',
    component: AxesComponent,
    title: "QUALIFPME | AXES",
  },
  {path: "**", component: ErrorComponent, title: "QUALIFPME | ERREUR 404"},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: QuicklinkStrategy,
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
